<div class="custom-tree-camp">
  <ng-container *ngFor="let node of dataSource; let i = index">
    <div class="custom-tree-group" [class.cm-menu-open]="node.expandable">
      <!-- Parent -->
      <!-- <div class="custom-tree-parent" tabindex="0" role="button" (keydown.enter)="travelerManagement(node)" (keyup.space)="travelerManagement(node)" (click)="travelerManagement(node)"> -->
      <div class="custom-tree-parent"
     tabindex="0"
     role="button"
     (keydown.enter)="onTravelerMenuClick(node)"
     (keyup.space)="onTravelerMenuClick(node)"
     (click)="onTravelerMenuClick(node)">
        <div class="custom-tree-heading">{{ node.name }}</div>
        <button mat-icon-button>
          <mat-icon fontSet="material-symbols-outlined">{{ node.expandable ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </button>
      </div>
      <!-- Children -->
        <div class="custom-tree-child-wrapper" *ngIf="node.expandable">
            <ng-container *ngFor="let child of node?.children">
                <button type="button" class="button-as-div custom-tree-child" [routerLink]="child.navigate" routerLinkActive="active"
                    (click)="onChildClick($event)">
                    <div class="custom-tree-heading">{{ child.name }}</div>
                </button>
            </ng-container>
        </div>


    </div>
  </ng-container>
</div>